import CreditRemainingAmount from './CreditRemainingAmount';

export default CreditRemainingAmount;
